import { render, staticRenderFns } from "./MultipleAvatar.vue?vue&type=template&id=26577e84&scoped=true&"
import script from "./MultipleAvatar.vue?vue&type=script&lang=js&"
export * from "./MultipleAvatar.vue?vue&type=script&lang=js&"
import style0 from "./MultipleAvatar.vue?vue&type=style&index=0&id=26577e84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26577e84",
  null
  
)

export default component.exports